import { useEffect } from 'react';

export function useDocumentMeta(title, description) {
  useEffect(() => {
    const previousTitle = document.title;
    const metaEl = document.querySelector('meta[name="description"]');
    const previousDescription = metaEl?.content;

    document.title = title;
    if (metaEl) metaEl.content = description;

    return () => {
      document.title = previousTitle;
      if (metaEl && previousDescription !== undefined) metaEl.content = previousDescription;
    };
  }, [title, description]);
}
